import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_Date",
  "use": "Ico_Date-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Ico_Date\">\n    <path data-name=\"Rectangle 7784\" style=\"fill:none\" d=\"M0 0h24v24H0z\" />\n    <path data-name=\"Union 15\" d=\"M-6198 4829a2 2 0 0 1-2-2v-10.5a1.5 1.5 0 0 1 1.5-1.5h.5v-2h2v2h8v-2h2v2h.5a1.5 1.5 0 0 1 1.5 1.5v10.5a2 2 0 0 1-2 2zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8h-14zm2-3v-3h3v3z\" transform=\"translate(6204 -4809)\" style=\"stroke:transparent;stroke-miterlimit:10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol